export default __webpack_public_path__ + "static/media/mobilegift.937ac2dc.svg";